import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ui from 'redux-ui';
import { connect } from 'react-redux';
import WorkroomFilters from 'components/Filters/WorkroomFilters';
import PageActionBar from 'components/PageActionBar';
import WorkroomList from './workroomList';
import WorkroomDetails from './workroomDetails';
import WorkroomNew from './workroomNew';
import WorkroomEdit from './workroomEdit';
import contentAreaStyles from 'styles/contentArea';
import { getRole, getEmployableType, getWorkroomFilters } from '../../../../reducers';
import { navigate, setWorkroomFilters, resetWorkroomFilters } from 'actionCreators';

class Workrooms extends Component {
  constructor(props) {
    super(props);
    this.addAction = this.addAction.bind(this);
    this.state = {
      showFilterDrawer: false,
    };
    this.toggleFilterDrawer = () => (
      this.setState({ showFilterDrawer: !this.state.showFilterDrawer }));
    this.handleFilterChange = filters => (
      this.props.setWorkroomFilters(filters)
    );
    this.isIndexRoute = () => (
      this.props.location.pathname === this.props.route.path);
  }

  onSearch = (e, value) => {
    e.preventDefault();
    const filters = { ...this.props.filters };
    filters.query = value;
    this.handleFilterChange(filters);
  }

  addAction = () => this.props.navigate('/workrooms/new');

  render = () => (<div>
    <PageActionBar
      hidesAddOnMobile
      resource="workroom"
      role={this.props.role}
      addAction={this.addAction}
      showFiltersBtn={this.isIndexRoute()}
      title="Workroom Management"
      searchText="Search for a workroom..."
      toggleFilters={this.toggleFilterDrawer}
      onSearch={this.onSearch}
      parentComponent="Workrooms"
      employableType={this.props.employableType}
    />
    <div className={contentAreaStyles.contentAreaContainer}>
      {this.props.children}
      <WorkroomFilters
        active={this.state.showFilterDrawer}
        onOverlayClick={this.toggleFilterDrawer}
        handleFilterChange={this.handleFilterChange}
        filters={this.props.filters}
        title="Workrooms"
        reset={this.props.resetWorkroomFilters}
        role={this.props.role}
        resource="workroom"
      />
    </div>
  </div>);
}

Workrooms.propTypes = {
  setWorkroomFilters: PropTypes.func.isRequired,
  navigate: PropTypes.func,
  location: PropTypes.object,
  route: PropTypes.object,
  role: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
  filters: PropTypes.object,
  resetWorkroomFilters: PropTypes.func.isRequired,
  employableType: PropTypes.string,
};

const mapStateToProps = state => ({
  role: getRole(state),
  employableType: getEmployableType(state),
  filters: getWorkroomFilters(state),
});

export default ui({ key: 'workrooms', state: { successMessage: '', activeTab: 0 } })(
  connect(mapStateToProps,
    { navigate, setWorkroomFilters, resetWorkroomFilters })(Workrooms));

export { WorkroomList, WorkroomDetails, WorkroomNew, WorkroomEdit };



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/workrooms/index.jsx